import db from "../db/database";
import { fetchFromBusinessCentral } from "../utils/businessCentralUtils";
import { isOnline } from "./syncService";

// Servicio para sincronizar Configuración de Grupos de Registro IVA
export const syncGruposIVA = async () => {
    if (!isOnline()) {
        return false;
    }

    try {
        console.log("Sincronizando Configuración de Grupos de Registro IVA...");

        // Obtener datos desde Business Central
        const serverVAT = await fetchFromBusinessCentral("ConfigGruposRegistroIVA");

        if (!serverVAT || serverVAT.length === 0) {
            console.warn("No se encontraron registros de IVA en Business Central");
            return false;
        }

        // Limpiar tabla antes de insertar 
        await db.grupoIVA.clear();

        // Insertar todos los registros
        const vatRecords = serverVAT.map(vat => ({
            VAT_Bus_Posting_Group: vat.VAT_Bus_Posting_Group || "",
            VAT_Prod_Posting_Group: vat.VAT_Prod_Posting_Group || "",
            Description: vat.Description || "",
            Blocked: vat.Blocked || false,
            VAT_Identifier: vat.VAT_Identifier || "",
            VAT_Percent: vat.VAT_Percent || 0,
            SRI_Tax_Code: vat.SRI_Tax_Code || "",
            SRI_VAT_Rate: vat.SRI_VAT_Rate || "",
            lastSynced: new Date(),
            lastModified: new Date()
        }));

        await db.grupoIVA.bulkAdd(vatRecords);

        console.log(`Configuración IVA sincronizada correctamente (${vatRecords.length} registros)`);

        return true;
    } catch (error) {
        console.error("Error al sincronizar Configuración de Grupos de Registro IVA:", error);
        return false;
    }
};


/**
 * Obtiene la configuración de IVA según
 * VAT_Bus_Posting_Group (PRODUCTO) y VAT_Prod_Posting_Group (CLIENTE)
 */
export const getVATByPostingGroups = async (
    VAT_Prod_Posting_Group,
    VAT_Bus_Posting_Group,
 
) => {
    try {
        return await db.grupoIVA
            .where("[VAT_Bus_Posting_Group+VAT_Prod_Posting_Group]")
            .equals([VAT_Bus_Posting_Group, VAT_Prod_Posting_Group])
            .first();
    } catch (error) {
        console.error("Error obteniendo configuración de IVA:", error);
        return null;
    }
};